<template>
    <el-drawer title="云场景日志" size="49%" custom-class="deviceDrawer cloudsceneDrawer" :visible.sync="drawer"
        direction="rtl" @open="drawerOpen">
        <div class="drawer-view" v-if="drawer">
            <div class="seach-view">
                <div class="left-view">
                    <div class="item" style="margin-right: .3rem;">
                        <div class="label">
                            时间区间
                        </div>
                        <div class="value">
                            <el-date-picker :editable="false" :clearable="false" v-model="timeValue" type="daterange"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            执行状态
                        </div>
                        <div class="value">
                            <el-select v-model="execState" placeholder="请选择执行状态">
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="right-view">
                    <div class="item item2" @click="searchClick">查询</div>
                    <div class="item" @click="resetClick">重置</div>
                </div>
            </div>
            <div class="list-view" v-if="list.length" @scroll="handleScroll" ref="scrollContainer">
                <div class="zw">
                    <i class="el-icon-time"></i>
                    <div class="clear-view" @click="clearLogs">
                        <i class="el-icon-delete"></i>
                        一键清除
                    </div>
                </div>
                <div class="item" v-for="(item, index) in list" :key="index">
                    <div class="item-title">{{ initTime(item.execDate) }}</div>
                    <div class="ele" v-for="(ele, ind) in item.contentList" :key="ind">
                        <div class="ele-top" @click="logsItemClick(ele)">
                            <div class="point">
                                <div class="yuan"></div>
                            </div>
                            <div class="time">{{ ele.execTime }}</div>
                            <div class="name">{{ ele.logName }}</div>
                            <div class="icon" :class="{ 'icon2': ele.check }">
                                <i class="el-icon-caret-bottom"></i>
                            </div>
                        </div>
                        <div class="result" v-if="ele.execState == '1'">执行成功</div>
                        <div class="result result2" v-else>执行失败</div>
                        <div class="ele-infos" v-if="ele.checkload" :class="{ 'ele-infos-open': ele.check }">
                            <div class="txt-name">触发条件（<template
                                    v-if="ele.conditionType == '0'">满足任意条件时</template><template
                                    v-else>满足全部条件时</template>）</div>
                            <div class="trigger-list">
                                <div class="td" v-for="(td, tdi) in ele.infos.logContent.cloud_scene_trigger"
                                    :key="tdi">
                                    <div class="satisfied" v-if="td.execState == '1'">已满足</div>
                                    <div class="satisfied satisfied3" v-else>未满足</div>
                                    <div class="name">{{ td.propertyName }}</div>
                                </div>
                            </div>
                            <div class="txt-name">执行动作</div>
                            <div class="trigger-list">
                                <div class="td" v-for="(td, tdi) in ele.infos.logContent.cloud_scene_execute"
                                    :key="tdi">
                                    <div class="satisfied" v-if="td.execState == '1'">执行成功</div>
                                    <div class="satisfied satisfied2" v-else>执行失败</div>
                                    <div class="name">{{ td.propertyName }}</div>
                                </div>
                            </div>
                            <div class="txt-name">生效时间段</div>
                            <div class="txt">
                                <template v-if="ele.infos.efficientProperty == '0'">全天</template>
                                <template v-else>
                                    {{ ele.infos.efficientData.startTime + " - " + ele.infos.efficientData.endTime
                                    }}<template v-if="showCR(ele.infos)">(次日)</template>
                                </template>
                                （<template v-if="ele.infos.efficientType != '4'">
                                    {{ backTxt2(ele.infos.efficientType) }}
                                </template>
                                <template v-else>
                                    {{ backWeekLabel(ele.infos.efficientData.type) }}
                                </template>）
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-view-no" v-else>
                <img class="table-noimg" src="@/assets/image/home/ZWT.png" alt="" />
                <div class="table-emptyword">暂无日志</div>
            </div>
        </div>

    </el-drawer>
</template>

<script>
export default {
    props: ["triggerTypeList", "timingTypeList", "weekTypeList"],
    data() {
        return {
            drawer: false,
            timeValue: [],
            options: [
                {
                    value: '0',
                    label: '失败'
                }, {
                    value: '1',
                    label: '成功'
                },
            ],
            execState: "",
            page: 1,
            limit: 6,
            haveMore: false,
            pickerOptions: {
                disabledDate(time) {
                    // 选择今天以及今天之前的日期
                    return time.getTime() > Date.now() // 如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            list: [
                // {
                //     execDate: "2025-06-11",
                //     week: "3",
                //     contentList: [
                //         {
                //             execState: "1",
                //             execTime: "18:13",
                //             logId: "1932742855543418882",
                //             logName: "18:13 只执行一次-控制阀2打开",
                //             check: false,
                //             infos: {
                //                 conditionType: "0",
                //                 efficientData: "00:00",
                //                 efficientProperty: "0",
                //                 efficientType: "0",
                //                 id: "1932742855543418882",
                //                 logContent: {
                //                     cloud_scene_execute: [
                //                         {
                //                             execState: "1",
                //                             operateType: "4",
                //                             propertyName: "控制阀2打开",
                //                             propertyType: "cloud_scene_execute",
                //                         },
                //                     ],
                //                     cloud_scene_trigger: [
                //                         {
                //                             propertyName: "18:13 只执行一次",
                //                             operateType: "1",
                //                             execState: "1",
                //                             propertyType: "cloud_scene_trigger"
                //                         }
                //                     ]
                //                 }
                //             }
                //         },
                //         {
                //             execState: "1",
                //             execTime: "18:13",
                //             logId: "1932742855543418882",
                //             logName: "18:13 只执行一次-控制阀2打开",
                //             check: false,
                //             infos: {
                //                 conditionType: "0",
                //                 efficientData: "00:00",
                //                 efficientProperty: "0",
                //                 efficientType: "0",
                //                 id: "1932742855543418882",
                //                 logContent: {
                //                     cloud_scene_execute: [
                //                         {
                //                             execState: "1",
                //                             operateType: "4",
                //                             propertyName: "控制阀2打开",
                //                             propertyType: "cloud_scene_execute",
                //                         },
                //                     ],
                //                     cloud_scene_trigger: [
                //                         {
                //                             propertyName: "18:13 只执行一次",
                //                             operateType: "1",
                //                             execState: "1",
                //                             propertyType: "cloud_scene_trigger"
                //                         }
                //                     ]
                //                 }
                //             }
                //         }
                //     ]
                // }
            ]
        }
    },
    methods: {
        loadMore() {
            console.log("到底了");
        },
        handleScroll() {
            const container = this.$refs.scrollContainer;
            // 判断是否滚动到达底部
            if (container.scrollHeight - container.scrollTop === container.clientHeight) {
                console.log('滚动到底部了！');
                // 可以在这里触发其他操作，如加载更多数据等
                this.getDataList();
            }
        },
        open() {
            this.timeValue = [];
            this.execState = "",
            this.drawer = true;
            this.getDataList(1);
        },
        logsItemClick(ele) {
            if (ele.checkload) {
                ele.check = !ele.check
            } else {
                let params = {
                    logId: ele.logId
                }
                this.$http.getAction(this.$api.cloudsceneloginfo, params).then((res) => {
                    if (res.data) {
                        if (res.data.efficientProperty == "1" || res.data.efficientType == "4") {
                            res.data.efficientData = JSON.parse(res.data.efficientData)
                        }
                        ele.infos = res.data
                        ele.conditionType = res.data.conditionType;
                        ele.check = !ele.check
                        ele.checkload = true
                    }
                })
            }

        },
        // 是否显示次日
        showCR(info) {
            console.log("执行");
            if (!this.compareTimes(info.efficientData.startTime, info.efficientData.endTime)) {
                return true
            }
            return false
        },
        compareTimes(time1, time2) {
            if (time1 == "") {
                return true;
            }
            if (time2 == "") {
                return true;
            }
            // 获取今天的日期
            const now = new Date();

            // 将时间字符串转换为 Date 对象，并假设日期是今天
            const time1Date = new Date(now.toDateString() + " " + time1);
            const time2Date = new Date(now.toDateString() + " " + time2);

            // 返回比较结果，true 表示 time1 早于 time2
            return time1Date < time2Date;
        },
        // 返回文字
        backTxt(operateType) {
            let arr = this.triggerTypeList.filter((item) => {
                return item.dictValue == operateType
            })
            if (!arr.length) {
                return null
            }
            return arr[0].dictLabel
        },
        // 返回星期几
        backWeekLabel(params) {
            let arr = []
            let indexArr = params.split(",")
            indexArr.sort((a, b) => a - b);
            indexArr.forEach((item) => {
                arr.push(this.weekTypeList[item].dictLabel)
            })
            if (arr.length == 7) {
                return "每天"
            }
            return arr.join(",")
        },
        backTxt2(operateType) {
            let arr = this.timingTypeList.filter((item) => {
                return item.dictValue == operateType
            })
            if (!arr.length) {
                return null
            }
            return arr[0].dictLabel
        },
        drawerOpen() {
            this.timeValue = [];
            this.execState = "",
            this.page = 1
            this.limit = 6
        },
        // 搜索
        searchClick() {
            this.getDataList(1)
        },
        // 重置
        resetClick() {
            this.timeValue = [];
            this.execState = "";
            this.getDataList(1)
        },
        formatTime(dateStr) {
            const date = new Date(dateStr);
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        initTime(date) {
            let formattedDate = date.replace(/-/g, '.');
            return formattedDate
        },
        getDataList(arg) {
            if (arg == 1) {
                this.haveMore = true;
                this.page = 1
            } else {
                if (!this.haveMore) {
                    return;
                }
                this.page = this.page + 1
            }
            let params = {
                startTime: "",
                endTime: "",
                execState: "",
                page: this.page,
                limit: this.limit,
            }
            if (this.timeValue.length) {
                params.startTime = this.timeValue[0]
                params.endTime = this.timeValue[1]
            }
            if (this.execState) {
                params.execState = this.execState
            }
            this.$http.postAction(this.$api.cloudscenelogpage, params).then((res) => {
                if (res.data && res.data.records) {
                    if (res.data.records.length < this.limit) {
                        console.log("到底了");
                        // 到底了
                        this.haveMore = false;
                    } else {
                        this.haveMore = true;
                    }
                    res.data.records.forEach((item) => {
                        item.contentList.forEach((ele) => {
                            ele.checkload = false;
                            ele.check = false;
                            ele.execTime = this.formatTime(ele.execTime)
                        })
                    })
                    if (arg == 1) {
                        this.list = res.data.records
                    } else {
                        this.list = [...this.list, ...res.data.records];
                    }
                } else {
                    if (arg == 1) {
                        this.list = []
                    }
                    // 到底了
                    this.haveMore = false;
                }
            })

        },
        clearLogs() {
            this.$confirm("是否清空所有云场景日志?", "一键清除", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                customClass: "del-cloudscene",
            })
                .then(() => {
                    this.$http.getAction(this.$api.cloudscenelogclearall).then((res)=>{
                        if(res.code == 200) {
                            this.getDataList(1);
                        }else {

                        }
                    })
                })
                .catch(() => { });
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .cloudsceneDrawer {
    border-radius: 0.225rem 0px 0px 0.225rem;

    .el-drawer__header {
        height: .625rem;
        box-sizing: border-box;
        text-align: left;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #454545;
        padding-top: 0;
        border-bottom: 1px solid #f1f1f1;
        margin-bottom: .325rem;

        span {
            font-size: 0.225rem;
        }
    }

    .el-drawer__close-btn {
        color: #454545;
    }

    .el-drawer__body {
        padding: 0 .4625rem 0.25rem .625rem;
        display: flex;
        flex-direction: column;
        text-align: left;
        flex: 1;
        overflow: auto;

        .drawer-view {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            overflow: auto;

            .seach-view {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: .225rem;
                border-bottom: 1px solid #E4E4E4;
                margin-bottom: .25rem;

                .left-view {
                    display: flex;
                    align-items: center;

                    .item {
                        display: flex;
                        align-items: center;

                    }

                    .label {
                        margin-right: .25rem;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        font-size: .2rem;
                        color: #333333;
                    }

                    .value {
                        width: 2.675rem;

                        .el-range-editor.el-input__inner {
                            padding-right: 0;
                            padding-left: .05rem;
                            width: 100%;
                            display: flex;
                            align-items: center;
                        }

                        .el-range-separator {
                            padding: 0;
                            width: .3125rem;
                        }

                        .el-range-input {
                            flex: 1;
                        }

                        .el-date-editor .el-range__close-icon {
                            width: .05rem;
                        }

                        .el-select {
                            width: 100%;
                        }

                        .el-icon-arrow-up:before {
                            content: '\e78f';
                        }
                    }
                }

                .right-view {
                    display: flex;
                    align-items: center;

                    .item {
                        cursor: pointer;
                        margin-left: 19px;
                        width: 79px;
                        height: 37px;
                        box-sizing: border-box;
                        border-radius: 8px;
                        border: 1px solid #999999;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .item2 {
                        background: #2DAEA9;
                        color: #FEFFFF;
                        border-color: #2DAEA9;
                    }

                }
            }

            .list-view {
                box-sizing: border-box;
                padding-left: .1375rem;
                padding-top: .3125rem;
                flex: 1;
                overflow: auto;

                .zw {
                    position: relative;
                    width: 100%;
                    height: .45rem;
                    border-left: .025rem solid #E4E4E4;

                    .el-icon-time {
                        position: absolute;
                        top: 2px;
                        left: 0;
                        transform: translateX(-50%) translateY(-100%);
                        color: #CECECE;
                        font-size: 24px;
                    }

                    .clear-view {
                        cursor: pointer;
                        position: absolute;
                        top: 2px;
                        right: 0;
                        transform:  translateY(-100%);
                        display: flex;
                        align-items: center;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        font-size: .175rem;
                        color: #E64343;
                        i {
                            font-size: .25rem;
                            color: #E64343;
                        }
                    }
                }

                .item {

                    .item-title {
                        padding-left: .225rem;
                        padding-bottom: .35rem;
                        border-left: .025rem solid #E4E4E4;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        font-size: 20px;
                        color: #333333;
                    }

                    .ele {
                        position: relative;
                        border-left: .025rem solid #E4E4E4;
                        padding-left: .225rem;
                    }

                    .ele-top {
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        padding-bottom: .275rem;

                        .point {
                            position: absolute;
                            top: 0;
                            left: 0;
                            transform: translateX(-50%);
                            width: .25rem;
                            height: .25rem;
                            background: #ffffff;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .yuan {
                                width: 10px;
                                height: 10px;
                                background: #2DAEA9;
                                border-radius: 50%;
                            }
                        }

                        .time {
                            width: .625rem;
                            margin-right: .2375rem;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                        }

                        .name {
                            flex: 1;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            font-size: .175rem;
                            color: #333333;
                        }

                        .icon {
                            transition: all .5s;

                            i {
                                color: #C9C9C9;
                            }
                        }

                        .icon2 {
                            transform: rotate(180deg);
                        }

                    }

                    .result {
                        padding-left: .8625rem;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        padding-bottom: .35rem;
                    }

                    .result2 {
                        color: #E64343;
                    }

                    .ele-infos {
                        transition: all .5s;
                        max-height: 0;
                        overflow: hidden;
                        padding: 0;
                        padding-left: 89px;

                        .txt-name {
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            margin-bottom: .175rem;
                        }

                        .trigger-list {
                            .td {
                                padding-left: .125rem;
                                display: flex;
                                align-items: center;
                                margin-bottom: .1375rem;

                                .satisfied {
                                    font-family: Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #2DAEA9;
                                    padding: 5px 7px;
                                    border: 1px solid #2DAEA9;
                                    border-radius: 4px;
                                }

                                .satisfied2 {
                                    color: #E64343;
                                    border: 1px solid #E64343;
                                }

                                .satisfied3 {
                                    color: #999999;
                                    border: 1px solid #999999;
                                }

                                .name {
                                    margin-left: .1rem;
                                    font-family: Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                }
                            }
                        }

                        .txt {
                            padding-left: .125rem;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                        }


                    }

                    .ele-infos-open {
                        max-height: 500px;
                        padding-left: 89px;
                        padding-bottom: .25rem;
                    }

                }
            }

            .list-view-no {
                box-sizing: border-box;
                padding-left: .1375rem;
                padding-top: .3125rem;
                flex: 1;
                overflow: auto;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .table-noimg {
                    width: 3rem;

                }

                .table-emptyword {
                    margin-top: .1875rem;
                    margin-bottom: .225rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    font-size: .175rem;
                    color: #999999;
                }
            }
        }
    }
}
</style>